export const environment = {
    apiMain: 'http://api.malicia-core.com/api/v1',
    deepLink: 'maliciamoda://',
    theme: 'main',
  };
  